import React, { useState, useEffect } from 'react';
import Hero from './sections/Hero';
import Features from './sections/Features';
import ModuleDetails from './sections/ModuleDetails';
import Statistics from './sections/Statistics';
import Technology from './sections/Technology';
import Contact from './sections/Contact';
import Navigation from './Navigation';
import PresentationMode from './PresentationMode';
import ShareMenu from './ShareMenu';
import '../styles/LandingPage.css';

const LandingPage: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isPresentationMode, setIsPresentationMode] = useState(false);

  useEffect(() => {
    document.title = 'Waymining FMS — Mining Fleet & Production Management';
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const exitPresentation = () => {
    setIsPresentationMode(false);
  };

  if (isPresentationMode) {
    return <PresentationMode onExit={exitPresentation} />;
  }

  return (
    <div className="landing-page">
      <Navigation scrolled={scrolled} />
      <Hero />
      <Features />
      <ModuleDetails />
      <Statistics />
      <Technology />
      <Contact />
      <ShareMenu onStartPresentation={() => setIsPresentationMode(true)} />
    </div>
  );
};

export default LandingPage;